<template>
<div id="app" class="about-us page-template-default page wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="about-us" :gotodownload="gotodownload" :apk="apk"/>

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article class="page type-page status-publish">
            <div class="inside-article">
              <Breadcrumbs class="page-crumb" :items="crumbs" />
              <header class="entry-header section-content" aria-label="Content">
                <h1 class="entry-title" itemprop="headline">About Us</h1>
              </header>

              <div class="section-content" itemprop="text">
                <p>
                  gbofficial.net is an independent information website that shares educational guides, version notes, feature explanations, and practical resources related to GB WhatsApp.
                </p>
                <p>
                  Our goal is to help visitors understand how third-party WhatsApp modification apps work, what features they may include, and what risks should be considered before installing any APK file.
                </p>

                <h2>What We Share</h2>
                <p>
                  We publish GB WhatsApp tutorials, download information, comparison articles, privacy notes, and troubleshooting content. The information is intended for general reference only.
                </p>

                <h2>Independent Website</h2>
                <p>
                  gbofficial.net is not affiliated with, endorsed by, sponsored by, or connected to WhatsApp LLC, Meta Platforms, Inc., or any official WhatsApp product.
                </p>
                <p>
                  WhatsApp, Meta, Android, Google Play, and other trademarks belong to their respective owners.
                </p>

                <h2>Third-Party App Information</h2>
                <p>
                  GB WhatsApp is a third-party modified application. It is not the official WhatsApp app and may not receive the same support, security review, or update process as official apps distributed through established app stores.
                </p>
                <p>
                  Visitors should review the source of any APK, back up important chats, and understand the potential account and privacy risks before using unofficial clients.
                </p>

                <h2>Contact</h2>
                <p>
                  If you notice outdated information or need to report an issue with our content, please contact the site owner through the contact method provided on gbofficial.net.
                </p>
              </div>

              <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'AboutUs',
  components: {
    HeadNav,
    Breadcrumbs,
  },
  data() {
    return {
      crumbs: [
        { label: 'Home', to: '/' },
        { label: 'About Us', to: '' },
      ],
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 20px !important;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

#maincontent {
  margin-top: 22px !important;
}
</style>
